import type { ReactNode } from "react";

// Covers the whole viewport, header included, so no Zudoku chrome (such as the
// Login button) shows through while we resolve or end a session.
export const FullScreen = ({ children }: { children: ReactNode }) => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 100,
      display: "grid",
      placeItems: "center",
    }}
    className="bg-background text-foreground"
  >
    <div className="flex flex-col items-center gap-4 text-center px-4">
      <span className="font-semibold text-2xl">Finarkein Docs</span>
      {children}
    </div>
  </div>
);
